export const setAlertStatusBg = (status, darkMode) => {
    switch (status) {
        case 'error': {
            return darkMode ? 'rgba(254, 178, 178, 0.16)' : null;
        }

        case 'info': {
            return darkMode ? 'rgba(144, 205, 244, 0.16)' : null;
        }

        case 'success': {
            return darkMode ? 'rgba(154, 230, 180, 0.16)' : null;
        }

        case 'warning': {
            return darkMode ? 'rgba(251, 211, 141, 0.16)' : null;
        }

        default: {
            return null;
        }
    }
};
